import { useState } from "react";
import { Menu, X, Calculator, Smartphone, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/data/content";
import { MessengerRow, PhoneLink } from "./ContactButtons";
import { SocialIcons } from "./SocialIcons";

const links = [
  { id: "calculator", label: "Калькулятор" },
  { id: "why", label: "Чому ADT" },
  { id: "process", label: "Як це працює" },
  { id: "experience", label: "Досвід" },
  { id: "gallery", label: "Галерея" },
  { id: "reviews", label: "Відгуки" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (!el) return;
    const headerOffset = window.innerWidth >= 1024 ? 130 : 84;
    const y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 z-50 w-full">
      {/* Utility strip — messengers (left) · phone (center) · socials (right) */}
      <div className="hidden border-b border-white/10 bg-black/90 backdrop-blur-xl lg:block">
        <div className="container mx-auto grid h-14 grid-cols-3 items-center px-4 sm:px-6 lg:px-8">
          <div className="flex justify-start">
            <MessengerRow size="sm" />
          </div>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="header-phone-center"
            className="flex items-center justify-center gap-2 font-heading text-lg font-bold tracking-wide text-white transition-colors hover:text-[#B12A2A] lg:text-xl"
          >
            <Smartphone className="h-6 w-6 text-[#B12A2A]" />
            {CONTACT.phoneDisplay}
          </a>
          <div className="flex justify-end">
            <SocialIcons size="sm" />
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className="border-b border-white/10 bg-black/80 backdrop-blur-xl">
        <div className="container mx-auto flex h-20 items-center justify-between px-4 sm:px-6 lg:px-8">
          <button onClick={() => go("top")} className="flex items-center" data-testid="header-logo">
            <img
              src="/logo-adt-v2.png"
              alt="ADT | Авто Для Тебе"
              className="h-11 w-auto object-contain sm:h-12 lg:h-14"
            />
          </button>

          <nav className="hidden items-center gap-7 xl:flex">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                data-testid={`nav-${l.id}`}
                className={`text-sm font-medium transition-colors hover:text-white ${
                  l.id === "calculator" ? "text-[#B12A2A]" : "text-white/70"
                }`}
              >
                {l.label}
              </button>
            ))}
            <Link
              to="/sofi"
              data-testid="nav-sofi"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#E08A85] transition-colors hover:text-white"
            >
              <Sparkles className="h-4 w-4" />
              Софі AI
            </Link>
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/sofi"
              data-testid="header-sofi-button"
              className="hidden items-center gap-2 rounded-md border border-[#B12A2A]/60 bg-[#B12A2A]/10 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#B12A2A]/25 sm:inline-flex"
            >
              <Sparkles className="h-4 w-4 text-[#B12A2A]" />
              Перевірити авто з Софі
            </Link>
            <button
              onClick={() => go("calculator")}
              data-testid="header-calculator-button"
              className="hidden items-center gap-2 rounded-md bg-[#B12A2A] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#C73D3A] sm:inline-flex"
            >
              <Calculator className="h-4 w-4" />
              Калькулятор розмитнення
            </button>

            <button
              onClick={() => setOpen((v) => !v)}
              className="text-white xl:hidden"
              aria-label="Меню"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="border-b border-white/10 bg-black px-4 pb-6 pt-2 xl:hidden" data-testid="mobile-menu">
          <Link
            to="/sofi"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-sofi"
            className="mb-3 mt-1 flex items-center justify-center gap-2 rounded-md bg-[#B12A2A] px-4 py-3.5 text-base font-semibold text-white transition-colors hover:bg-[#C73D3A]"
          >
            <Sparkles className="h-5 w-5" />
            Перевірити авто з Софі AI
          </Link>
          <nav className="flex flex-col">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => go(l.id)}
                className={`border-b border-white/5 py-3 text-left text-base font-medium ${
                  l.id === "calculator" ? "text-[#B12A2A]" : "text-white/80"
                }`}
              >
                {l.label}
              </button>
            ))}
          </nav>
          <div className="mt-5 flex flex-col gap-5">
            <PhoneLink className="text-base text-white" />
            <MessengerRow />
            <SocialIcons size="lg" />
          </div>
        </div>
      )}
    </header>
  );
};
